import React, { useState } from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';

const KnobFrame = styled.div({
    position: 'absolute',
    bottom: 0,
    color: 'white',
    backgroundColor: 'rgba(0,0,0,0.4)',
    pointerEvents: 'auto',
    transition: 'translate bottom top 0.3s',
    padding: '0.6em',
    borderRadius: '0.5em 0.5em 0 0'
});

const KnobIconWrapper = styled.div<{ slideOut: boolean }>(props => ({
    padding: 0, margin: 0,
    transform: props.slideOut ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: 'transform 0.3s',
}));

function PanelKnob(props: { slideOut: boolean, onClick: () => void }) {
    const { slideOut } = props;
    return <KnobFrame {...props}>
        <KnobIconWrapper slideOut={slideOut}>
            <FontAwesomeIcon icon={faAngleUp} size='1x' />
        </KnobIconWrapper>
    </KnobFrame>;
}

const SlideOut = styled.div<{ slideOut: boolean }>(props => ({
    margin: 0,
    position: 'relative',
    bottom: 0,
    transform: props.slideOut ? 'translate(0, 100%)' : 'translate(0, 0)',
    transition: 'transform 0.3s'
}));

export function KnobbedDrawer(props: React.PropsWithChildren<{}>) {
    const { children } = props;

    const [lowerVisible, setLowerVisible] = useState(false);

    return (
        <>
            <SlideOut slideOut={lowerVisible}>
                {children}
            </SlideOut>
            <PanelKnob slideOut={lowerVisible} onClick={() => setLowerVisible(prev => !prev)} />
        </>
    );
}
